import { TagInfo } from "@stepfinance/react";
import type { FC } from "react";

type VaultTitleProps = {
  description: string;
  isVoltage: boolean;
  isStaked?: boolean;
  remainingLockupDays?: number;
};

export const VaultTitlePopover: FC<VaultTitleProps> = ({ description, isVoltage, isStaked, remainingLockupDays }) => {
  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <span> {description} </span>
      <span>{isVoltage && <TagInfo tagType="text">High Voltage</TagInfo>}</span>
      {isStaked && (
        <TagInfo useSpaceMono={false} uppercase={false} tagType="text">
          Staked
        </TagInfo>
      )}
      {remainingLockupDays && remainingLockupDays > 0 ? (
        <TagInfo useSpaceMono={false} uppercase={false} tagType="text">
          Locked for {remainingLockupDays} days
        </TagInfo>
      ) : null}
    </div>
  );
};
